import controller from './bill-info-add.controller';

export default {
  bindings: {
    msisdn: '<',
    invoice: '=',
    offerable: '<'
  },
  controller,
  template: require('./bill-info-add.html')
};


// WEBPACK FOOTER //
// src/app/no-auth/components/bill-info-add/bill-info-add.component.ts